const INITIAL_STATE = {
  showButtons: 0
};

export const collectiveHomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SHOW_COLLECTIVE_BUTTONS':
      return {
        ...state,
        showButtons: action.payload
      };
    default:
      return state;
  }
};
